import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=95bd2e98&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=95bd2e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bd2e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95bd2e98')) {
      api.createRecord('95bd2e98', component.options)
    } else {
      api.reload('95bd2e98', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=95bd2e98&scoped=true&", function () {
      api.rerender('95bd2e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/Inspection/edit.vue"
export default component.exports